import {Link} from 'react-router-dom'
import clsx from 'clsx'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {useLayout} from '../../core'
import {useThemeMode} from '../../../partials'
import {useState} from 'react'
import {useIntl} from 'react-intl'

const SidebarLogo = () => {
  const intl = useIntl()
  const {config} = useLayout()
  const theme = useThemeMode()
  const appSidebarDefaultMinimizeDesktopEnabled =
    config?.app?.sidebar?.default?.minimize?.desktop?.enabled
  const appSidebarDefaultCollapseDesktopEnabled =
    config?.app?.sidebar?.default?.collapse?.desktop?.enabled
  const toggleType = appSidebarDefaultCollapseDesktopEnabled
    ? 'collapse'
    : appSidebarDefaultMinimizeDesktopEnabled
    ? 'minimize'
    : ''
  const toggleState = appSidebarDefaultMinimizeDesktopEnabled ? 'active' : ''
  const appSidebarDefaultMinimizeDefault = config.app?.sidebar?.default?.minimize?.desktop?.default

  const [showSidebar, setShowSidebar] = useState(true)

  const toggleSidebar = () => {
    if (showSidebar) {
      const body = document.getElementById('kt_app_body')
      body?.setAttribute('data-kt-app-sidebar-minimize', 'on')
    } else {
      const body = document.getElementById('kt_app_body')
      body?.setAttribute('data-kt-app-sidebar-minimize', '')
    }

    setShowSidebar(!showSidebar)
  }

  return (
    <div className='app-sidebar-logo px-6' id='kt_app_sidebar_logo'>
      {/* <Link to='/dashboard'>
        {config.layoutType === 'dark-sidebar' ? (
          <>
            {showSidebar && (
              <span className=' pt-1 fw-bolder text-dark fs-1 text-center '>
                Hola 123aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa
              </span>
            )}
          </>
        ) : (
          <>
            {showSidebar && (
              <span className=' pt-1 fw-bolder text-dark fs-1 text-center '>
                {intl.formatMessage({id: 'MENU_VERTICAL'})}
              </span>
            )}
          </>
        )}

        <img
          alt='Logo'
          src={toAbsoluteUrl('/media/logos/logoRentaCar.webp')}
          className='h-40px app-sidebar-logo-minimize'
        />
      </Link> */}

      <Link to='/dashboard'>
        {config.layoutType === 'dark-sidebar' ? (
          <img
            alt='Logo'
            src={theme.mode === 'light' ? toAbsoluteUrl('/media/logos/reservasbo.png') : toAbsoluteUrl('/media/logos/reservasbo-dark.png')}
            className='h-60px app-sidebar-logo-default'
          />
        ) : (
          <>
            <img
              alt='Logo'
              src={theme.mode === 'light' ?toAbsoluteUrl('/media/logos/reservasbo.png') : toAbsoluteUrl('/media/logos/reservasbo-dark.png')}
              className='h-60px app-sidebar-logo-default theme-light-show'
            />
            <img
              alt='Logo'
              src={theme.mode === 'light' ? toAbsoluteUrl('/media/logos/reservasbo.png') : toAbsoluteUrl('/media/logos/reservasbo-dark.png')}
              className='h-60px app-sidebar-logo-default theme-dark-show'
            />
          </>
        )}

        <img
          alt='Logo'
          // src={toAbsoluteUrl('/media/logos/logoRentaCar.webp')}
          src={theme.mode === 'light' ? toAbsoluteUrl('/media/logos/logoReservaBo.png'): toAbsoluteUrl('/media/logos/logoReservaBo-dark.png')}
          className='h-40px app-sidebar-logo-minimize'
        />
      </Link>

      <div
        className={clsx(
          'app-sidebar-toggle btn btn-icon btn-shadow btn-sm btn-color-muted btn-active-color-primary body-bg h-30px w-30px position-absolute top-50 start-100 translate-middle'
        )}
        onClick={toggleSidebar}
      >
        <span
          style={{
            transform: showSidebar ? 'rotate(0deg)' : 'rotate(180deg)',
            transition: 'transform 0.3s ease-in-out', // Transición suave
          }}
        >
          <KTSVG path='/media/icons/duotune/arrows/arr079.svg' className='svg-icon-2 rotate-90' />
        </span>
      </div>
    </div>
  )
}

export {SidebarLogo}
